import { styled } from "@mui/material/styles";
import { Box, IconButton } from "@mui/material";
import { colors } from "../../../theme/colors";

export const NavigationContainer = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: "50px",
  left: "50%",
  transform: "translateX(-50%)",
  maxWidth: "320px",
  width: "90%",
  backgroundColor: "white",
  borderRadius: "16px",
  boxShadow: "0px 3px 6px #00000029;",
  padding: "12px 0",
  zIndex: 1000,
}));

export const NavigationItemsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
}));

export const NavigationIconButton = styled(IconButton)(
  ({ theme, isActive }) => ({
    flexDirection: "column",
    padding: "8px",
    borderRadius: "12px",
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.05)",
    },
  })
);

export const ActiveIndicator = styled(Box)(({ theme }) => ({
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  backgroundColor: colors.primary,
  marginTop: "2px",
}));
